import React from 'react'
import logoLight from '../../assets/images/logo-light.png'
import todoIcon from '../../assets/icons/microsoft/todo.png'
import outlookIcon from '../../assets/icons/microsoft/outlook.png'
import academyLogo from '../../assets/images/academyLogo.jpeg'

/** Chrome visual do Oikos de hoje (HorizontalLayout) — só cenário; não navega. */
const TOPNAV = [
  { icon: 'ri-user-3-line', label: 'RH' },
  { icon: 'ri-community-line', label: 'Patrimônio' },
  { icon: 'ri-article-line', label: 'Dep. técnico' },
  { icon: 'ri-shopping-cart-2-line', label: 'Comercial' },
  { icon: 'ri-global-line', label: 'Financeiro' },
  { icon: 'ri-building-4-line', label: 'Gerência' },
]

export default function OikosLiveShell({ children, onClose, caseLabel }) {
  return (
    <div className="erp-screen-live" role="dialog" aria-modal="true" aria-label="Exemplo no Oikos">
      <div className="erp-oikos-shell__exit">
        <span>
          Exemplo no Oikos de hoje
          {caseLabel ? ` · ${caseLabel}` : ''}
          {' '}
          — o menu acima é o chrome real (cenário); Esc fecha
        </span>
        <button type="button" className="erp-oikos-shell__exit-btn" onClick={onClose}>
          Fechar
        </button>
      </div>

      <div className="erp-oikos-shell">
        <header className="erp-oikos-shell__topbar" aria-hidden>
          <div className="erp-oikos-shell__brand">
            <img src={logoLight} alt="" height={36} />
          </div>
          <div className="erp-oikos-shell__utils">
            <span className="erp-oikos-shell__icon" title="NFT">
              <svg viewBox="0 0 200 200" width="22" height="22" aria-hidden>
                <polygon points="50,50 150,50 150,150 50,150" fill="#4CAF50" />
                <polygon points="50,50 100,20 200,20 150,50" fill="#81C784" />
                <polygon points="150,50 200,20 200,120 150,150" fill="#388E3C" />
              </svg>
            </span>
            <span className="erp-oikos-shell__icon">
              <img src={todoIcon} alt="" width={22} height={22} />
            </span>
            <span className="erp-oikos-shell__icon">
              <img src={outlookIcon} alt="" width={22} height={22} />
            </span>
            <span className="erp-oikos-shell__academy">
              <img src={academyLogo} alt="" height={22} />
            </span>
            <span className="erp-oikos-shell__expediente">Encerrar expediente</span>
            <span className="erp-oikos-shell__user">
              <span className="erp-oikos-shell__avatar" />
              Joao
              <i className="mdi mdi-chevron-down" />
            </span>
          </div>
        </header>

        <nav className="erp-oikos-shell__topnav" aria-hidden>
          <ul>
            {TOPNAV.map((item) => (
              <li key={item.label}>
                <span>
                  <i className={`${item.icon} mr-1`} />
                  {item.label}
                  <span className="erp-oikos-shell__caret" />
                </span>
              </li>
            ))}
          </ul>
        </nav>

        <div className="erp-oikos-shell__page">{children}</div>
      </div>
    </div>
  )
}
